export enum FunctionAppEditMode {
  ReadWriteSourceControlled,
  ReadOnlySourceControlled,
  ReadWrite,
  ReadOnly,
  ReadOnlySlots,
  ReadOnlyVSGenerated,
  ReadWriteVSGenerated,
  ReadOnlyRunFromZip,
  ReadOnlyLocalCache,
  ReadOnlyLinuxDynamic,
  ReadOnlyBYOC,
  ReadOnlyPython,
  ReadOnlyJava,
  ReadOnlyLinuxCodeElastic,
}



// WEBPACK FOOTER //
// ./src/app/shared/models/function-app-edit-mode.ts